import { Check } from "lucide-react"

const proofPoints = [
  "$4B+ capital requested",
  "4k+ businesses supported",
  "180+ vetted lenders",
]

/**
 * The compressed proof carried onto the mobile form screen. The full panel is
 * a screen behind at this point, so the credit-check reassurance and the
 * headline numbers are restated here, where the borrower is actually typing.
 */
export function FormProofPills() {
  return (
    <div className="mb-6 flex flex-col items-start gap-2.5 lg:hidden">
      <Pill>No credit check at this step</Pill>
      <div className="flex flex-wrap items-center gap-1.5">
        {proofPoints.map((point) => (
          <Pill key={point}>{point}</Pill>
        ))}
      </div>
    </div>
  )
}

function Pill({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex items-center gap-1 rounded-xl border border-neutral-200 bg-white px-2 py-1 whitespace-nowrap">
      <Check className="text-primary size-3 shrink-0" strokeWidth={2.4} />
      <span className="text-[11px] font-medium text-neutral-700">
        {children}
      </span>
    </div>
  )
}
